import BaseJoi from "joi";
import moment from "moment-timezone";

export const SCHEDULE_MIN_MINUTES = 30;
export const SCHEDULE_MAX_DAYS = 30;

let activeScheduleTimezone: string | undefined;
export const setActiveScheduleTimezone = (
  timezone: string | undefined
): void => {
  activeScheduleTimezone = timezone;
};

export const scheduleBoundViolation = (
  value: string | null | undefined,
  timezone?: string
): "min" | "max" | null => {
  if (!value) return null;

  const [datePart, timePart] = value.split("T");
  if (!datePart || !timePart) return null;

  const selected = timezone ? moment(value).tz(timezone, true) : moment(value);
  if (!selected.isValid()) return null;
  const selectedTime = selected.valueOf();

  const now = Date.now();
  const minTime = now + SCHEDULE_MIN_MINUTES * 60 * 1000;
  const maxTime = now + SCHEDULE_MAX_DAYS * 24 * 60 * 60 * 1000;

  if (selectedTime < minTime) return "min";
  if (selectedTime > maxTime) return "max";
  return null;
};

export const scheduleMinDateTime = (timezone?: string): string => {
  const m = moment().add(SCHEDULE_MIN_MINUTES, "minutes");
  return (timezone ? m.tz(timezone) : m).format("YYYY-MM-DDTHH:mm");
};

export const scheduleMaxDateTime = (timezone?: string): string => {
  const m = moment().add(SCHEDULE_MAX_DAYS, "days");
  return (timezone ? m.tz(timezone) : m).format("YYYY-MM-DDTHH:mm");
};

export const scheduleJoi: BaseJoi.Root = BaseJoi.extend((joi) => ({
  type: "datetimeLocal",
  base: joi.string(),
  messages: {
    "datetimeLocal.min": "Schedule time must be at least 30 minutes from now",
    "datetimeLocal.max": "Schedule time must be within 30 days from now",
  },
  validate(value, helpers) {
    const violation = scheduleBoundViolation(value, activeScheduleTimezone);
    if (violation === "min") {
      return { value, errors: helpers.error("datetimeLocal.min") };
    }
    if (violation === "max") {
      return { value, errors: helpers.error("datetimeLocal.max") };
    }
    return { value };
  },
}));

export const datetimeLocalSchema = (): BaseJoi.StringSchema =>
  (
    scheduleJoi as unknown as { datetimeLocal: () => BaseJoi.StringSchema }
  ).datetimeLocal();

export const toScheduledDate = (value: string, timezone: string): Date =>
  moment(value).tz(timezone, true).toDate();
